export enum RecAiPage {
  ProductDetails = 0,
  Home = 1,
  Cart = 2,
  MyAccount = 3,
}
